import React from 'react';
import api from './apiConnector'

import ListDevis from './listDevis'
import Details from './details'
import Documents from './documents';
import Comparateurs from './comparateurs'
import CopyBox from './copyBox'
import CopyToClipboard from 'react-copy-to-clipboard';
import working from './img/working.png'

import { StatusMarker, StatusPicker } from './status'
import ItemTabBar from './itemTabBar';
import Timeline from './timeline'
import SearchBar from './searchBar'
import Tarifs from './tarifs'
import tools from './img/tools-line.png'

import warningImg from './img/error-warning-line.png'

const typeToSponsor = {'motoecole':'Moto-école','concessionnaire':'Concessionnaire'}

class CommercialList extends React.Component {

    constructor(props) {

        super(props);
    }

    onChange(event) {
        this.props.container.setCommercial(event.target.value)
    }

    render() {
        let me = this
        if ( !this.props.isAdmin ) {
            let commercial = this.props.commercial
            if ( commercial=='false' ) commercial = false
            if ( commercial ) {
                return <span>{commercial}</span>
            } else {
                return <button onClick={e=>{
                    e.stopPropagation()
                    me.props.container.setCommercial(me.props.user)
                }}>Prendre ce devis</button>
            }
        } else {
            let options = this.props.users.map(
                user=><option key={user.login} value={user.login}>{user.login}</option>
            )
            return <select onChange={this.onChange.bind(this)}
                onClick={e=>{e.stopPropagation()}}
                value={this.props.commercial}>
                <option value={false}>-</option>
                {options}
            </select>
        }
    }
}

class Devis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unfold:false,
            editComment:'',
            copied:false,
            searchName:'',
            fetchingSolly:false
        }
        this.dateFormatter = new Intl.DateTimeFormat('fr',{ dateStyle: 'short', timeStyle: 'short' })
        this.handlerRefreshCalculating = false
    }    

    componentDidUpdate( prevProps, prevState ) {
        this.checkCalculatingRefresh()
    }

    componentDidMount() {
        this.checkCalculatingRefresh()
    }

    checkCalculatingRefresh() {
        const {maxance,axa} = this.props.devis

        if (( maxance?.calculating || axa?.calculating )&& ! this.handlerRefreshCalculating ) {
            this.handlerRefreshCalculating = window.setInterval( this.refreshCalculating.bind(this), 3000 )
        }
        if (( !( maxance?.calculating || axa?.calculating ))&& this.handlerRefreshCalculating ) {
            this.stopRefrechCalculating()
        }
    }

    stopRefrechCalculating() {
        if ( this.handlerRefreshCalculating ) {
            window.clearInterval( this.handlerRefreshCalculating )
            this.handlerRefreshCalculating = false
        }
    }

    componentWillUnmount() {
        this.stopRefrechCalculating()
    }

    refreshCalculating() {
        const {_id,type,maxance,axa} = this.props.devis
        let ignore = {}
        if ( maxance?.calculating ) ignore['maxance.calculating'] = this.props.devis.maxance.calculating
        if ( axa?.calculating ) ignore['axa.calculating'] = this.props.devis.axa.calculating
        api.post(
            {   action:'get_devis',
                id:type+_id.$oid,
                ignore_fields:JSON.stringify(ignore)
            }
        )
    }

    pickStatus(status) {
        this.props.container.pickStatus(this.props.devis._id.$oid,status)
    }

    setCommercial(commercial) {
        this.props.container.setCommercial(this.props.devis._id.$oid,commercial)
    }

    sendDevisEmail(onSuccess) {
        if ( window.confirm('Envoyer le devis à '+this.props.devis.params.email) ) {
            this.props.container.sendDevisEmail(this.props.devis._id.$oid,onSuccess)
        } else {
            onSuccess()
        }
    }

    onComment() {
        this.props.container.setComment(this.props.devis._id.$oid,this.state.editComment)
        this.setState({editComment:''})
    }

    capitalizeFirstLetter(string) {
        return string ?( string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() ): ''
    }
      
    getTarif(formule) {
        const warranties = this.props.devis.params.warranties
        if ( warranties ) {
            const found = warranties.find( row => row.Z_FORM == formule )
            return found ? found.Z_MTAN+' €' : ''
        }
        return ''
    }

    unfoldMarker(e) {
        this.openTimeline(e)
    }

    openTimeline(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'timeline'})
    }

    openEmailList(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        if ( this.props.topLevel ) {
            this.setState({unfold:'emaillist'})
        }
    }

    openClient(e) {
        if (e && e.target ) {
            e.stopPropagation()
        }
        api.openFront(this.props.devis)
    }

    openSolly(e) {
        const {devis} = this.props
        if (e && e.target ) {
            e.stopPropagation()
        }
        if (( devis.solly_validated>=1 )&& devis.solly_url ) {
            window.open(devis.solly_url)
        }
    }

    openDetails(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'details'})
    }


    openTarifs(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'tarifs'})
    }

    openDocuments(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'documents'})
    }

    openComparateurs(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'comparateurs'})
    }

    fold() {
        if ( this.state.unfold ) {
            this.setState({unfold:false})
        } else {
            this.setState({unfold:this.props.devis.params.nom?'timeline':'comparateurs'})
        }
    }

    setStatusProcess(option) {
        this.props.container.setStatusProcess(this.props.devis._id.$oid,option)
    }

    renderTimeline() {

        return <Timeline container={this} devis={this.props.devis} api={api}/>
    }

    renderDetails() {
        return <Details container={this} api={api} devis={this.props.devis}/>
    }

    renderComparateurs() {
        return <Comparateurs container={this} api={api} devis={this.props.devis}/>
    }

    renderEmailList() {
        return <ListDevis 
            container={this} 
            increment={0}
            type={this.props.devis.type}
            api={api} 
            email={this.props.devis.params.email} 
            avoid={this.props.devis._id.$oid}
            filterName=""
            searchStatus={[]}
        />
    }

    renderDocuments() {
        return <Documents container={this} api={api} devis={this.props.devis}/>
    }

    renderStatus() {
        return <StatusPicker container={this} api={api} status={this.props.devis.status}/>
    }

    renderTarifs() {
        return <Tarifs container={this} api={api} devis={this.props.devis}/>
    }


    renderUnfolded(type) {
        try {
            let content = ''
            switch ( this.state.unfold ) {
                case 'timeline':
                    content = this.renderTimeline()
                    break
                case 'emaillist':
                    content = this.renderEmailList()
                    break
                case 'details':
                    content =  this.renderDetails()
                    break
                case 'comparateurs':
                    content = this.renderComparateurs()
                    break
                case 'status':
                    content = this.renderStatus()
                    break
                case 'tarifs':
                    content = this.renderTarifs()
                    break
                case 'documents':
                    content = this.renderDocuments()
                    break
                }
            if ( content ) {
                return <React.Fragment>
                    <ItemTabBar operator={this.props.operator} hasValidSolly={(this.props.devis.solly_validated>=1)} container={this} tab={this.state.unfold} type={type} showClient={true} />
                    <div className="unfolded_block">
                    {content}
                    </div>
                </React.Fragment>
            } else {
                return content
            }
        } catch ( e ) {
            console.log(e)
            return 'Erreur interne'
        }
    }

    fetchSolly(e) {
        e.stopPropagation()
        this.setState({fetchingSolly:true})
        const me = this
        api.post(
            {   action:'goons_tarif',
                id:this.props.devis.typedId()
            },
            ()=>{
                me.setState({fetchingSolly:false})
            },
            ()=>{
                me.setState({fetchingSolly:false})
            }
        )
    }

    fetchMaxance(createDevis,e) {
        e.stopPropagation()
        const id = this.props.devis._id.$oid
        this.props.updateDevisField(id,'maxance',{calculating:1})
        api.post(
            {   action:'maxance_tarification',
                id:id,
                create_devis:createDevis?'1':'0'
            }
        )
    }

    fetchAxa(e,memorize=false) {
        e.stopPropagation()
        const id = this.props.devis._id.$oid
        this.props.updateDevisField(id,'axa',{calculating:1})
        api.post(
            {   action:'axa_tarification',
                id:id,
                ... ( memorize && { memorize:'1' } )
            }
        )
    }

    validateSolly(e) {
        e.stopPropagation()
        this.setState({fetchingSolly:true})
        const me = this
        api.post(
            {   action:'goons_validate',
                id:this.props.devis.typedId()
            },
            ()=>{
                me.setState({fetchingSolly:false})
            },
            ()=>{
                me.setState({fetchingSolly:false})
            }
        )
    }

    renderMaxanceBox() {
        try {
            const {devis} = this.props
            const maxance = devis.getMaxance().setChoicesFromDevis().setFancy('-','')
            const prevMaxance = maxance.prevMaxance().setChoicesFromDevis().setFancy('-','')
            const errorMessage = maxance.error || null

            const Monthly =  ({className,maxance})=><span className={className} title={errorMessage}>{maxance.fancyPrice(maxance.coutTotal())}<br/>{maxance.fancyPrice(maxance.acompte())}<br/>{maxance.fancyPrice(maxance.echeance())}</span>
            const Yearly = ({className,maxance})=><span className={className} title={errorMessage}>{maxance.fancyPrice(maxance.coutTotal())}<br/>{maxance.fancyPrice(maxance.acompte())}<br/>-</span>
            if ( maxance.calculating ) return '...'
            if ( maxance.hasTarifs() &&( maxance.fractionnement == 'M' )) return <Monthly maxance={maxance}/>
            if ( maxance.hasTarifs() &&( maxance.fractionnement == 'A' )) return <Yearly maxance={maxance}/>
            if ( prevMaxance.hasTarifs() &&( prevMaxance.fractionnement == 'M' )) return <Monthly maxance={prevMaxance} className="stroke"/>
            if ( prevMaxance.hasTarifs() &&( prevMaxance.fractionnement == 'A' )) return <Yearly maxance={prevMaxance} className="stroke"/>

            if ( maxance.error ) return <span title={maxance.error}>Erreur Maxance</span>
            return <></>
        } catch (e) { console.log(e) ; return <>Erreur interne</> }
    }


    renderAxaBox() {
        try {
            const {devis} = this.props
            const {axa_num_client,axa_num_instance} = devis.params
            const axa = devis.getAxa().setChoicesFromDevis().setFancy('-','')
            const prevAxa = axa.prevAxa().setChoicesFromDevis().setFancy('-','')

            const ErrorBox = ({axa})=>{
                if ( axa.error ) {
                    if ( axa.error === 'logout' ) return <span title="AXA déconnecté">🛇</span>
                    else return <span title={axa.error}>Erreur AXA</span>
                }
                return null
            }
            const errorMessage = ( ( axa.error === 'logout' ) ? "AXA déconnecté" : axa.error ) || null

            if ( axa.calculating ) return '...'
            
            const Monthly = ({className,axa})=><><span className={className} title={errorMessage}>{axa.fancyPrice(axa.coutTotal())}<br/>{axa.fancyPrice(axa.echeance())}<br/>{axa.fancyPrice(axa.echeance())}</span></>
            const Yearly = ({className,axa})=><><span className={className} title={errorMessage}>{axa.fancyPrice(axa.coutTotal())}<br/>{axa.fancyPrice(axa.coutTotal())}<br/>-</span></>

            if ( axa.hasTarifs() ) {
                if ( axa.fractionnement == 'monthly' ) return <Monthly axa={axa}/>
                if ( axa.fractionnement == 'yearly' ) return <Yearly axa={axa}/>
            } else if ( prevAxa.hasTarifs() ) {
                if ( prevAxa.fractionnement == 'monthly' ) return <Monthly axa={prevAxa} className="stroke"/>
                if ( prevAxa.fractionnement == 'yearly' ) return <Yearly axa={prevAxa} className="stroke"/>
            }

            return <ErrorBox axa={axa}/>

        } catch (e) { console.log(e) ; return <>Erreur interne</> }
    }

    renderApporteur() {
        const {params,affiliate} = this.props.devis
        if ( affiliate ) {
            return 'Affilié '+affiliate
        } 
        return ( 'Ref_Partenaire' in params ) ? params.Ref_Partenaire : 'Website'
    }

    buttonsMaxance() {
        const {devis} = this.props
        const {maxance} = devis

        /* if ( maxance?.calculating ) return <>Calcul en cours ...</> */
        return <><button className={devis.maxance?.calculating?'maxance fetching':'maxance'} disabled={maxance?.calculating}
            onClick={maxance?.calculating ? undefined : this.fetchMaxance.bind(this,false)}>Tarifer</button>
            <button className={devis.maxance.calculating?'maxance fetching':'maxance'} disabled={maxance?.calculating}
            onClick={maxance?.calculating ? undefined : this.fetchMaxance.bind(this,true)}>Devis</button>
        </>
    }

    tdMaxance() {

        return <td onClick={this.openTarifs.bind(this)} className="narrow_right narrow_left maxance">                   
            {this.renderMaxanceBox()}
        <br/>
        {this.buttonsMaxance()}
       </td>   
    }

    tdAxa() {
        const {devis} = this.props
        const calculating = devis.axa && devis.axa.calculating
        const classes = ['narrow_right','narrow_left','axa']
        if ( this.axaAlert() ) classes.push('axa_alert')
        return <td onClick={this.openTarifs.bind(this)} className={classes.join(' ')}>                   
            {this.renderAxaBox()}
        <br/>
        { <button className={calculating?'axa fetching':'axa'}
            onClick={ calculating ? undefined : (e)=>{ this.fetchAxa(e,true)} }>Recalculer</button> }
       </td>   
    }

    tdFma() {
        const {devis} = this.props
        const fma = devis.getFma().setChoicesFromDevis().setFancy('-','')
        const hasFma = fma.hasTarifs()
        
        return <td onClick={this.openTarifs.bind(this)} className="narrow_right narrow_left fma">
            {hasFma && <>
                {fma.fancyPrice( fma.coutTotal())}<br/>
                {fma.fancyPrice( fma.comptant())}<br/>
                { ( fma.fractionnement == 'M' )?fma.fancyPrice( fma.mensuel() ):'-' }
            </>}
            { fma.error && fma.error!='Désactivé' && <span title={fma.error}>Erreur FMA</span>}
        </td>
    }

    axaAlert() {
        const {devis} = this.props
        const axa = devis.getAxa().setChoicesFromDevis()
        if ( !axa.hasTarifs() ) return false
        const axaCost = axa.coutTotal()
        const xenaCost = devis.toPayYearly(true,true)
        if ( !( axaCost && xenaCost )) return false
        if ( xenaCost > axaCost ) return true
    }

    originClassName() {
        const {devis} = this.props
        return [ 
            ...( devis.axa_reply ? ['axa_reply'] : [] ),
            ...( devis.fma_reply ? ['fma_reply'] : [] )
        ].join(' ')
    }

    render() {
        
        const {operator,devis} = this.props
        const {params,tb} = devis
        const {type} = devis
        const isMoto = type=='moto'

        const tdBranch = <td className={'branch_cell'+(tb ? ' branch_cell_'+tb : '')}>{tb && tb.toUpperCase()}</td>
        try {
            let filtered = params.filtered
            if ( filtered &&( filtered.length > 24 )) filtered = filtered.substring(24)
            else filtered = ''

            if ( devis.fma?.error && !params.nom ) {
                return <React.Fragment>
                    <tr onClick={this.fold.bind(this)} className={this.originClassName()}><td className="nowrap">
                            <img title="Détails du devis" src='img/search-2-line.png' className='button' onClick={this.openComparateurs.bind(this)}/>
                        </td>
                        <td colSpan={isMoto?5:4} className="fma">{devis.fma.error}</td>
                        <td>{this.props.devis.cm} ({this.props.devis.cc})</td>
                        <td>{devis.axa_reply&&'AXA '}{( 'Ref_Partenaire' in params )?params.Ref_Partenaire:'Website'}</td>
                        <td>{params.date_effet}</td>
                        <td>{this.dateFormatter.format(1000*params.Abp_Timestamp)}</td></tr>
                    <tr className={this.state.unfold ? 'unfolded':'folded'}><td colSpan="11">{this.renderUnfolded('error')}</td></tr>
                </React.Fragment> 
            }

            if ( params.error && !params.nom ) {
                return <React.Fragment>
                    <tr onClick={this.fold.bind(this)} className={this.originClassName()}><td className="nowrap">
                            <img title="Détails du devis" src='img/search-2-line.png' className='button' onClick={this.openComparateurs.bind(this)}/>
                        </td>
                        <td colSpan={isMoto?5:4}>{params.error}{filtered}</td>
                        <td>{this.props.devis.cm} ({this.props.devis.cc})</td>
                        <td>{devis.axa_reply&&'AXA '}{( 'Ref_Partenaire' in params )?params.Ref_Partenaire:'Website'}</td>
                        <td>{params.date_effet}</td>
                        <td>{this.dateFormatter.format(1000*params.Abp_Timestamp)}</td></tr>
                    <tr className={this.state.unfold ? 'unfolded':'folded'}><td colSpan="11">{this.renderUnfolded('error')}</td></tr>
                </React.Fragment> 
            }

            return (this.props.quotations || !params.nom) ? <React.Fragment>
                <tr onClick={this.fold.bind(this)} className={this.originClassName()}>
                    <td className="nowrap">
                        <img title="Voir l'historique" src='img/time-line.png' className='button' onClick={this.openTimeline.bind(this)}/>
                        <img title="Rédiger un commentaire" src='img/pencil-line.png' className='button' onClick={this.openTimeline.bind(this)}/>
                        <img title="Détails du devis" src='img/search-2-line.png' className='button' onClick={this.openDetails.bind(this)}/>
                    </td>
                    {isMoto?<>
                        <td>{this.getTarif('M2')}</td>
                        <td>{this.getTarif('M3')}</td>
                        <td>{this.getTarif('M4')}</td>
                        <td>{this.getTarif('M7')}</td>
                    </>:<>
                        <td>{this.getTarif('L1')}</td>
                        <td>{this.getTarif('L2')}</td>
                        <td>{this.getTarif('L3')}</td>
                    </>}
                    <td onClick={this.openDetails.bind(this)}>{params.marque+' / '+params.modele+(params.cylindree?(' ('+params.cylindree+')'):'')}</td>
                    <td>{params.sra?params.sra:(this.props.devis.cm+' '+this.props.devis.cc)}</td>
                    <td>{devis.axa_reply&&'AXA '}{( 'Ref_Partenaire' in params )?params.Ref_Partenaire:'Website'}</td>
                    <td>{params.date_effet}</td>
                    <td>{params.Abp_Timestamp ? this.dateFormatter.format(1000*params.Abp_Timestamp) : ''}</td>
                </tr>
                <tr className={this.state.unfold ? 'unfolded':'folded'}>
                    <td colSpan="11">{this.renderUnfolded('tarif')}</td>
                </tr>
            </React.Fragment> 
            : 
            <React.Fragment>
                <tr onClick={this.fold.bind(this)} className={'progress_'+devis.getStage()+' '+(this.originClassName())}>
                    {tdBranch}
                    {operator ? <td>
                        <CommercialList container={this} commercial={devis.commercial} users={this.props.users} user={api.getLogin()} isAdmin={api.isAdmin()}/>
                    </td> : <></>}
                    <td>
                        <StatusMarker container={this} status={this.props.devis.status || 'Non traité'} unfolded={this.props.unfoldedMarker}/>
                        { this.props.devis.synchronized ? '' : <img className="working" src={working} title="Ce dossier est en cours de modification"/> }
                        {((devis.validated<0)||( params.validated &&( params.validated < 0 )))?<img src={tools} className="working" title="Devis en attente de validation pas Xenassur. Souscription impossible avant validation."/>:''}
                    </td>
                    <td onClick={this.openDetails.bind(this)}>
                        {params.nom.toUpperCase()+' '+this.capitalizeFirstLetter( params.prenom )}
                    </td>
                    <td onClick={this.openDetails.bind(this)} className="wrapword">
                        {params.email}
                    </td>
                    <td onClick={this.openDetails.bind(this)}>
                        <CopyBox text={'0'+params.telephone}/>
                    </td>
                    <td onClick={this.openTarifs.bind(this)}>
                        {params.error ? <span title={params.error}>Erreur Xenassur</span> :
                        <>
                            {this.props.devis.toPayYearly(true)}<br/>{this.props.devis.toPay(true)}<br/>{(params.periodicite=='M')?this.props.devis.toPayMonthly(false,true):'-'}
                        </>}
                    </td>

                    {/* SollyAzar Tarifs */}

                    {(operator&&isMoto)?<><td onClick={this.openTarifs.bind(this)} className={this.state.fetchingSolly?'fetching narrow_right narrow_left solly':'narrow_right narrow_left solly'}>
                                                
                        {devis.hasSollyTarifs()
                        ? ( 
                            (( !params.periodicite )||( params.periodicite=='A'))
                            ? (
                                <>{devis.sollyAnnuel()}<br/>{devis.sollyAnnuel()}<br/>-</>
                            ) : (
                                <>{devis.sollyCoutTotalMensuel()}<br/>{devis.sollyAcompte()}<br/>{devis.sollyMensuel()}</>
                            )
                        ) : ''}
                        {( devis.solly_validated < 0 ) ? <span title={devis.solly_error||''}>Erreur Solly</span> : ''}
                        <br/>

                        {( !devis.solly_ref )?<button className={this.state.fetchingSolly?'fetching solly':'solly'}
                            onClick={this.state.fetchingSolly ? undefined : this.fetchSolly.bind(this)}>Tarifer</button>: '' }
                        {( devis.solly_ref &&(( devis.solly_validated == 0 )||( devis.solly_validated == -1 ))) ? <button 
                            className={this.state.fetchingSolly?'fetching solly':'solly'} 
                            onClick={this.validateSolly.bind(this)}>Valider</button> : ''}
                        {( devis.solly_ref &&( devis.solly_validated == 1 )) ? <button 
                            className="solly checked">Validé</button> : ''}                    

                    </td>

                    {isMoto?this.tdMaxance():<></>}
                    {isMoto?this.tdAxa():<></>}
                    {isMoto?this.tdFma():undefined}

                    
                    </>:<></>}

                    { !! operator && <td>
                        {params.subscribeId 
                            ? <>Xena Contrat <CopyBox text={params.subscribeId}/></>
                            : params.idt && <>Xena Devis<CopyBox text={params.idt}/></>
                        }

                        {!!params.axa_num_instance
                            && <span className="axa">AXA Instance<CopyBox text={params.axa_num_instance}/></span>}
                        {((!params.axa_num_instance)&& devis.prev_axa_num_instance )
                            && <span className="axa stroke">AXA Instance<CopyBox text={devis.prev_axa_num_instance} className="stroke"/></span>}
                        {devis.fma?.numero_police && <span className="fma">FMA police<CopyBox text={devis.fma.numero_police}/></span>}
                        {devis.maxance?.ref && <span className="maxance">Devis Maxance<CopyBox text={devis.maxance.ref}/></span>}
                        {devis.prev_maxance?.ref && !devis.maxance?.ref && <span className="maxance stroke">Devis Maxance<CopyBox text={devis.prev_maxance.ref}/></span>}
                    </td> }

                    <td onClick={this.openDetails.bind(this)}>{params.marque+' / '+params.modele+' ('+(isMoto?params.cylindree:params.sra)+')'}</td>
                    {( operator && isMoto )?<td>{devis.cm} ({devis.cc})</td>:<></>}
                    <td onClick={this.openTimeline.bind(this)} >
                        {operator?SearchBar.statusProcessToLabel(devis.status_process):SearchBar.statusProcessToLabelAffiliate(devis.status_process)}
                        {( devis.subscriber &&( devis.status_process != 'ongoing' )&&( devis.status_process != 'subscribed_solly' ))?<><br/>par {devis.subscriber}</>:<></>}
                    </td>
                    <td onClick={this.openTimeline.bind(this)}>{devis.axa_reply&&'AXA '}{this.renderApporteur()}</td>
                    {operator?<>
                    <td><CopyBox text={devis._id.$oid} displayText={devis._id.$oid.substring(0,6)+'...'}/>
                    {params.trans_uuid?<><CopyBox text={params.trans_uuid} displayText={params.trans_uuid.substring(0,6)+'...'}/></>:<></>}
                    </td>
                    <td>{(params.MER in Devis.merToLabel )? Devis.merToLabel[params.MER] : '-'}</td>
                    </>:<></>}
                    <td>{params.date_effet}</td>
                    <td>{this.dateFormatter.format(1000*this.props.devis.last_modification)}</td>
                    <td>{this.dateFormatter.format(1000*params.Abp_Timestamp)}</td>
                    <td>{devis.getStageText()}</td>
                </tr>
                { /* this.props.devis.has_devis?'':<tr onClick={this.openDetails.bind(this)}><td></td><td colSpan="12"><img src={warningImg} className="inline-icon"/> Erreur lors de l'édition du devis {params.error ? ('- Message de xenassur: '+params.error):''}</td></tr> */ }
                {((this.props.devis.status_process=='subscribe_error')||(this.props.devis.status_process=='presubscribe_error'))?<tr onClick={this.openDetails.bind(this)} className="error"><td></td><td colSpan="9"><img src={warningImg} className="inline-icon"/> Erreur lors de la souscription {params.error ? (' : '+params.error):''}</td></tr>:''}
                {(this.props.devis.getting_documents<0)?<tr onClick={this.openDetails.bind(this)} className="error"><td></td><td colSpan="9"><img src={warningImg} className="inline-icon"/> Erreur lors de la récupération des documents ! Le client n'a pas reçu ses documents.</td></tr>:''}

                {/*(( devis.solly_validated < 0 )&&operator )? <tr onClick={this.fold.bind(this)} className="error_solly"><td colSpan="3"></td><td colSpan="15"><b>Sollyazar ▸ </b> {devis.solly_error||''}</td></tr> : ''*/}

                <tr className={this.state.unfold ? 'unfolded':'folded'}><td colSpan="15">{this.renderUnfolded(params.subscribeId?'subscribed':'devis')}</td></tr>
            </React.Fragment>
        } catch ( e ) {
            console.log(e)
            return <tr><td colSpan="14">Erreur interne sur le devis {devis._id.$oid}</td></tr>
        }
    }
}

Devis.merToLabel = {
    'M':'Mail',
    'C':'Courrier',
    'T':'Téléphone',
    'W':'Web call back',
    'S':'Souscrire en ligne'
}

export default Devis;
